import { useFormikContext } from "formik"
import { makeStyles } from "tss-react/mui"
import { Stack, Typography, Box } from "@mui/material"
import { ExternalLink } from "../../../../../../shared/components/links/ExternalLink"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { FormikTextField } from "../../../../../../shared/components/forms/Formik"
import { CompanyFormValues } from "../companyTypes"

const useStyles = makeStyles()((theme) => ({
    cardContentLink: {
        color: theme.palette.tailwind.sky[500],
        textDecoration: "none",
        transition: "all ease-in-out 0.3s",
        "&:hover": {
            color: `${theme.palette.tailwind.sky[800]}`,
        },
    },
}))

export function CompanySelfSignUpAccordion({ url }: { url?: string }) {
    const { classes } = useStyles()

    const { values } = useFormikContext<CompanyFormValues>()

    return (
        <Stack direction="column" spacing={2}>
            <LocalizedStrict id="support-create-company-url-identifier-label" attrs={{ label: true, helperText: true }}>
                <FormikTextField<CompanyFormValues>
                    fullWidth
                    disabled={!values.isSelfSignUp}
                    name="urlIdentifier"
                    label="Signup URL identifier"
                    helperText="This is used for generating the user signup URL."
                />
            </LocalizedStrict>
            {url && (
                <Box>
                    <LocalizedStrict id="support-create-company-signup-link-subtitle">
                        <Typography mb={1}>Signup link:</Typography>
                    </LocalizedStrict>
                    <ExternalLink href={url} className={classes.cardContentLink}>
                        {url}
                    </ExternalLink>
                </Box>
            )}
        </Stack>
    )
}
